import { Injectable, input } from '@angular/core';
import { Subject } from 'rxjs';
import { SpinnerType } from '../spinner.type';

@Injectable({
  providedIn: 'root',
})
export class SpinnerService {
  isLoading$ = new Subject<boolean>();
  isLoadingUserData$ = new Subject<boolean>();

  show(type?: SpinnerType): void {
    switch (type) {
      case 'userData':
        this.isLoadingUserData$.next(true);
        break;
      default:
        this.isLoading$.next(true);
        break;
    }
  }

  hide(type?: SpinnerType): void {
    switch (type) {
      case 'userData':
        this.isLoadingUserData$.next(false);
        break;
      default:
        this.isLoading$.next(false);
        break;
    }
  }
}
